import { render } from "./OutletShowComponent.vue?vue&type=template&id=5156863c"
import script from "./OutletShowComponent.vue?vue&type=script&lang=js"
export * from "./OutletShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Outlet/OutletShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5156863c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5156863c', __exports__)) {
    api.reload('5156863c', __exports__)
  }
  
  module.hot.accept("./OutletShowComponent.vue?vue&type=template&id=5156863c", () => {
    api.rerender('5156863c', render)
  })

}


export default __exports__